import './index.css';
import axios from 'axios';

import React, { useRef, useEffect, useState } from 'react';

export default function Culture() {
    const [height, setHeight] = useState('100px')
 
    useEffect(() => {
     var h = document.body.clientHeight
     console.log(h,'获取屏幕高度')
     setHeight(h)
    }, [])
 
    return (
        <div>
            <>
                <iframe
                    src="http://cpc.people.com.cn/"
                    title="Baidu"
                    width="100%"
                    height={height+'px'}
                    style={{ border: 'none'}}
                />
            </>
        </div>
    );
}
